"use client";

import { c as _c } from "react/compiler-runtime";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import GradientButton from "@/components/atoms/GradientButton";
import useValidateEmail from "./useValidateEmail";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
type Props = {
  handleCodeValidated: () => void;
  onCompleteLater?: () => void;
  hideCompleteLater?: boolean;
  submitLabel?: string;
};
export default function ValidateEmail(t0) {
  const $ = _c(41);
  const {
    handleCodeValidated,
    onCompleteLater,
    hideCompleteLater,
    submitLabel
  } = t0;
  useRouter();
  let t1;
  if ($[0] !== handleCodeValidated) {
    t1 = {
      handleCodeValidated
    };
    $[0] = handleCodeValidated;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    form,
    onSubmit,
    isPendingRecoverPwd,
    handleResendValidationCode,
    t
  } = useValidateEmail(t1);
  let t2;
  if ($[2] !== form || $[3] !== onSubmit) {
    t2 = form.handleSubmit(onSubmit);
    $[2] = form;
    $[3] = onSubmit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem className="w-full flex flex-col items-center"><FormLabel className="text-center text-lg mb-2">{t("codeLabel")}</FormLabel><FormControl><InputOTP maxLength={8} {...field} inputMode="numeric" pattern={"\\d*"} autoFocus={true}><InputOTPGroup className="gap-1"><InputOTPSlot index={0} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /><InputOTPSlot index={1} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /><InputOTPSlot index={2} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /><InputOTPSlot index={3} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /><InputOTPSlot index={4} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /><InputOTPSlot index={5} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /><InputOTPSlot index={6} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /><InputOTPSlot index={7} className="w-10 h-10 md:w-12 md:h-12 text-2xl border-2" /></InputOTPGroup></InputOTP></FormControl><FormDescription className="text-center mt-2 text-md w-full px-4">{t("codeDescription")}</FormDescription><FormMessage /></FormItem>;
    };
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== form.control || $[8] !== t3) {
    t4 = <FormField control={form.control} name="emailCode" render={t3} data-sentry-element="FormField" data-sentry-source-file="ValidateEmail.tsx" />;
    $[7] = form.control;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("resendCode");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleResendValidationCode || $[13] !== t5) {
    t6 = <span onClick={handleResendValidationCode} className="mt-10 underline cursor-pointer">{t5}</span>;
    $[12] = handleResendValidationCode;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="flex flex-col justify-center items-center py-16 w-full">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== submitLabel || $[19] !== t) {
    t8 = submitLabel ?? t("validateButton");
    $[18] = submitLabel;
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t8) {
    t9 = <p className="text-white text-lg">{t8}</p>;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== isPendingRecoverPwd || $[24] !== t9) {
    t10 = <GradientButton isLoading={isPendingRecoverPwd} type="submit" className="w-full h-12" data-sentry-element="GradientButton" data-sentry-source-file="ValidateEmail.tsx">{t9}</GradientButton>;
    $[23] = isPendingRecoverPwd;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== handleCodeValidated || $[27] !== hideCompleteLater || $[28] !== onCompleteLater || $[29] !== t) {
    t11 = !hideCompleteLater && <Button onClick={onCompleteLater ?? handleCodeValidated} variant="outline" type="button" className="w-full h-12 mt-6 rounded-xl"><p className="text-lg ">{t("completeLater")}</p></Button>;
    $[26] = handleCodeValidated;
    $[27] = hideCompleteLater;
    $[28] = onCompleteLater;
    $[29] = t;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t7) {
    t12 = <div className="flex justify-center flex-col items-center w-full">{t7}{t10}{t11}</div>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t7;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t2) {
    t13 = <form data-testid="validate-email-form" onSubmit={t2} className="w-full">{t12}</form>;
    $[35] = t12;
    $[36] = t2;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== form || $[39] !== t13) {
    t14 = <Form {...form} data-sentry-element="Form" data-sentry-component="ValidateEmail" data-sentry-source-file="ValidateEmail.tsx">{t13}</Form>;
    $[38] = form;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  return t14;
}